import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions, DialogContent, TextField } from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';
import { UserModel } from 'models/UserModel';


type InviteAdminDialogProps = {
} & ModalActionProps<UserModel>;

const InviteAdminDialog = ({ onFinish }: InviteAdminDialogProps) => {
    const {t} = useTranslation();
    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const data = Object.fromEntries(new FormData(event.currentTarget).entries()) as any;

        onFinish({
            ...data,
        });
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <TextField
                    id="email"
                    name="email"
                    label={t('email')}
                    fullWidth
                    type="email"
                    required
                />

                <TextField
                    id="phone"
                    name="phone"
                    label={t('phone')}
                    fullWidth
                    type="tel"
                />

                <TextField
                    autoFocus
                    id="lastName"
                    name="lastName"
                    label={t('last_name')}
                    fullWidth
                    required
                />

                <TextField
                    id="firstName"
                    name="firstName"
                    label={t('first_name')}
                    fullWidth
                    required
                />
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('invite')}</Button>
            </DialogActions>
        </Box>
    );
};

export default InviteAdminDialog;
